import React from 'react'
import ArtistSection from './ArtistSection'
import StarRating from '../UI/StarRating'
import { formatDateRange, getEventStatus } from '../../utils/dateUtils'

const EventInfo = ({ event, user, onArtistToggle, onCommentClick, onAssignDay }) => {

  return (
    <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-8">
      <EventHeader event={event} />
      <EventDetails
        event={event}
        user={user}
        onArtistToggle={onArtistToggle}
        onCommentClick={onCommentClick}
        onAssignDay={onAssignDay}
      />
    </div>
  )
}

const EventHeader = ({ event }) => {

  return (
    <div className="border-b border-white/10 pb-6 mb-6">
      <div className="flex items-start justify-between">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <h1 className="text-3xl font-bold text-white">{event.name}</h1>
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
              getEventStatus(event.startDate) === 'upcoming'
                ? 'bg-green-500/20 text-green-300 border border-green-500/30'
                : 'bg-gray-500/20 text-gray-300 border border-gray-500/30'
            }`}>
              {getEventStatus(event.startDate)}
            </span>
          </div>
          <p className="text-gray-300 text-lg mb-4">{event.description}</p>
        </div>
        {event.rating && <StarRating rating={event.rating} />}
      </div>
    </div>
  )
}


const EventDetails = ({ event, user, onArtistToggle, onCommentClick, onAssignDay }) => (
  <div className="grid md:grid-cols-2 gap-8 mb-8">
    <LeftColumn
      event={event}
      user={user}
      onArtistToggle={onArtistToggle}
      onCommentClick={onCommentClick}
      onAssignDay={onAssignDay}
    />
    <RightColumn event={event} />
  </div>
)

const LeftColumn = ({ event, user, onArtistToggle, onCommentClick, onAssignDay }) => (
  <div className="space-y-6">
    <EventDetailsSection event={event} />
    <ArtistSection
      event={event}
      user={user}
      onArtistToggle={onArtistToggle}
      onCommentClick={onCommentClick}
      onAssignDay={onAssignDay}
    />
  </div>
)

const EventDetailsSection = ({ event }) => (
  <div>
    <h3 className="text-lg font-semibold text-white mb-3">📅 Event Details</h3>
    <div className="space-y-3">
      <EventDetailItem
        icon={<CalendarIcon />}
        text={formatDateRange(event.startDate, event.endDate)}
      />
      <EventDetailItem
        icon={<LocationIcon />}
        text={`${event.venueName}, ${event.country}`}
      />
    </div>
  </div>
)

const EventDetailItem = ({ icon, text }) => (
  <div className="flex items-center gap-3">
    {icon}
    <span className="text-gray-300">{text}</span>
  </div>
)

const CalendarIcon = () => (
  <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 012 0v4m0 0V3a1 1 0 012 0v4m0 0h4m-4 0h4m-4 0v13a1 1 0 01-1 1H7a1 1 0 01-1-1V7m2 0h4m-4 0h4" />
  </svg>
)

const LocationIcon = () => (
  <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
)

const RightColumn = ({ event }) => (
  <div className="space-y-6">
    {event.notes && (
      <div>
        <h3 className="text-lg font-semibold text-white mb-3">📝 Notes</h3>
        <p className="text-gray-300 whitespace-pre-wrap">{event.notes}</p>
      </div>
    )}

    {event.top10 && (
      <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-500/30 rounded-xl p-4">
        <div className="flex items-center gap-3">
          <svg className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
          <span className="text-yellow-200 font-medium">Top 10 Event</span>
        </div>
      </div>
    )}
  </div>
)

export default EventInfo